import { Controller } from '@hotwired/stimulus'
import Datepicker from 'flowbite-datepicker/Datepicker'
import DateRangePicker from 'flowbite-datepicker/DateRangePicker'

// Used in: Schools calendar partial, filter form date partial, admin form date partial, no newcomer period form
// Purpose: Add flowbite js datepicker to source target
// Refactor: since we are not using range, can remove range

export default class extends Controller {
  static targets = ['source']
  static values = {
    range: Boolean
  }
  connect() {
    console.log('datepicker controller connected')
    const options = {
      format: 'dd-mm-yyyy',
      autohide: true,
      todayBtn: true,
      todayBtnMode: 1,
      todayHighlight: true,
      clearBtn: true
    }

    const input = this.sourceTarget.querySelector('input')

    if (input.value) {
      try {
        let inputValue = input.value

        // Handle dd.mm format or dd-mm format
        if (/^\d{2}[.-]\d{2}$/.test(inputValue)) {
          const [day, month] = inputValue.split(/[.-]/)
          inputValue = `${new Date().getFullYear()}-${month}-${day}`
        }
        // Handle dd-mm-yyyy format
        else if (/^\d{2}-/.test(inputValue)) {
          const [day, month, year] = inputValue.split('-')
          inputValue = `${year}-${month}-${day}`
        }

        const date = new Date(inputValue)

        // Check if date is valid
        if (isNaN(date.getTime())) {
          throw new Error('Invalid date')
        }

        // Format with padding
        const formattedDate = `${String(date.getDate()).padStart(
          2,
          '0'
        )}-${String(date.getMonth() + 1).padStart(
          2,
          '0'
        )}-${date.getFullYear()}`
        input.value = formattedDate
      } catch (error) {
        console.error('Error formatting date:', error)
        input.value = '' // Clear invalid date
      }
    }

    this.datepickerInstance = new Datepicker(input, options)
  }

  disconnect() {
    if (this.datepickerInstance) {
      this.datepickerInstance.destroy()
      console.log('datepicker controller disconnected')
    }
  }
}
